/*eslint-disable*/
import './App.css';
import './reset.css'
import './seik-style.css'
import { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Offcanvas, Button } from 'react-bootstrap';
import Main from './component/Main'
import Section1 from './component/Section1';
import Section3 from './component/Section3';
import Section4 from './component/Section4';
import Section5 from './component/Section5';
import Section6 from './component/Section6';
import Footer from './component/Footer';
import $ from 'jquery';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretDown, faMagnifyingGlass, faGlobe, faArrowUp, faBars } from '@fortawesome/free-solid-svg-icons'

function App() {

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    
    const handleResize = () => {
      // 윈도우 크기 변경 시 수행할 작업
      updateRoleElements();
    };

    const updateRoleElements = () => {
      // 크기가 변경될 때 수행할 업데이트 로직
      var wd = $(window).width()
      $(".nav_right").css("display", "")
      $(".nav_Btn").css("display", "none")
      $("#navLogo4").attr({"src": `${process.env.PUBLIC_URL}/navLogo4.png`, width: "38px"}).css("marginLeft", "0px")

      if (wd > 1280) {
        setNav([
          { key: 'dropA, txtA', value: ai("게임정보") },
          { key: 'dropA, txtA', value: ai("새소식") },
          { key: 'txtA', value: "다운로드" },
          { key: 'txtA', value: ai45("E스포츠") },
          { key: 'dropA, txtA', value: ai("이벤트") },
          { key: 'dropA, txtA', value: ai("알아보기") },
          { key: 'txtA', value: ai45("유니버스") },
          { key: 'txtA', value: ai45("라이엇 스토어") },
          { key: 'txtA', value: ai45("고객지원") }
        ])

        setDropdown([["기본정보", "챔피언", "패치노트"],
        ["전체", "게임 업데이트", "개발자 블로그", "세계관", "미디어", "라이엇 스토어", "E스포츠", "라이엇 게임즈", "커뮤니티", dropLink("서버 점검 및 업데이트"), "티모 문화유산 원정대"],
        [dropLink("PC방 이벤트"), dropLink("PC방 습격! 이벤트")],
        ["LoL 디스플레이", "모바일 상점", "라이엇 모바일", "아바타 생성기"]])

      } else if (wd > 1080) {
        setNav([
          { key: 'dropA, txtA', value: ai("게임정보") },
          { key: 'dropA, txtA', value: ai("새소식") },
          { key: 'txtA', value: "다운로드" },
          { key: 'txtA', value: ai45("E스포츠") },
          { key: 'dropA, txtA', value: ai("이벤트") },
          { key: 'dropA, txtA', value: ai("알아보기") },
          { key: 'dropA, txtA', value: ai("더보기") },])

        setDropdown([["기본정보", "챔피언", "패치노트"],
        ["전체", "게임 업데이트", "개발자 블로그", "세계관", "미디어", "라이엇 스토어", "E스포츠", "라이엇 게임즈", "커뮤니티", dropLink("서버 점검 및 업데이트"), "티모 문화유산 원정대"],
        [dropLink("PC방 이벤트"), dropLink("PC방 습격! 이벤트")],
        ["LoL 디스플레이", "모바일 상점", "라이엇 모바일", "아바타 생성기"],
        [dropLink("유니버스"), dropLink("라이엇 스토어"), dropLink("고객지원")]])

      } else if (wd > 980) {
        setNav([
          { key: 'dropA, txtA', value: ai("게임정보") },
          { key: 'dropA, txtA', value: ai("새소식") },
          { key: 'txtA', value: "다운로드" },
          { key: 'txtA', value: ai45("E스포츠") },
          { key: 'dropA, txtA', value: ai("이벤트") },
          { key: 'dropA, txtA', value: ai("더보기") },])

        setDropdown([["기본정보", "챔피언", "패치노트"],
        ["전체", "게임 업데이트", "개발자 블로그", "세계관", "미디어", "라이엇 스토어", "E스포츠", "라이엇 게임즈", "커뮤니티", dropLink("서버 점검 및 업데이트"), "티모 문화유산 원정대"],
        [dropLink("PC방 이벤트"), dropLink("PC방 습격! 이벤트")],
        ["알아보기", dropLink("유니버스"), dropLink("라이엇 스토어"), dropLink("고객지원")]])

      } else if (wd > 880) {
        setNav([
          { key: 'dropA, txtA', value: ai("게임정보") },
          { key: 'dropA, txtA', value: ai("새소식") },
          { key: 'txtA', value: "다운로드" },
          { key: 'txtA', value: ai45("E스포츠") },
          { key: 'dropA, txtA', value: ai("더보기") },])

        setDropdown([["기본정보", "챔피언", "패치노트"],
        ["전체", "게임 업데이트", "개발자 블로그", "세계관", "미디어", "라이엇 스토어", "E스포츠", "라이엇 게임즈", "커뮤니티", dropLink("서버 점검 및 업데이트"), "티모 문화유산 원정대"],
        ["이벤트", "알아보기", dropLink("유니버스"), dropLink("라이엇 스토어"), dropLink("고객지원")]])

      } else {
        setNav([])
        setDropdown([])
        $(".nav_right").css("display", "none")
        $(".nav_Btn").css("display", "block")
        $("#navLogo4").attr({"src": `${process.env.PUBLIC_URL}/navLogo5.png`, width: "90px"}).css("marginLeft", "20px")
      }

    };
    updateRoleElements();

    // 이벤트 리스너 등록
    window.addEventListener('resize', handleResize);

    // 컴포넌트가 마운트 해제되면 이벤트 리스너 제거
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const ai = (text) => (
    <>
      {text}&nbsp;&nbsp;&nbsp;<span><FontAwesomeIcon icon={faCaretDown} style={{ fontSize: "14px" }} /></span>
    </>
  );

  const ai45 = (text) => (
    <>
      {text}&nbsp;<span><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)" }} /></span>
    </>
  );

  const dropLink = (text) => (
    <>
      {text}&nbsp;&nbsp;
      <span><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)", fontSize: "10px", color: "#707070" }} /></span>
    </>
  );

  const handleOnA = (event) => {
    const targetElement = event.currentTarget;
    const hasDropAClass = targetElement.classList.contains('dropA');
    const txtAIndex = Array.from(targetElement.parentElement.getElementsByClassName('txtA')).indexOf(targetElement);
    $(".txtA").removeClass("active")
    $(".dropdown").css("opacity", 0);
    $(".nav_bar").css({ width: 0 });
    setTxtAIndex(txtAIndex)
    var txtA = $(".txtA").eq(txtAIndex)

    if (hasDropAClass) {
      const dropAIndex = Array.from(targetElement.parentElement.getElementsByClassName('dropA')).indexOf(targetElement);
      setDropAIndex(dropAIndex);
      var dropDonw = $(".dropdown").eq(dropAIndex)
      dropDonw.css({ "opacity": 1 })
      $(".nav_bar").css({ width: "215px", left: txtA.offset().left })
    } else {
      $(".nav_bar").css({ width: txtA.width() + parseFloat(txtA.css('padding-left')) * 2 + "px", left: txtA.offset().left })
    }
    $(".nav_bar_box").css({ width: txtA.width() + 33 + "px", left: txtA.offset().left })
    targetElement.classList.add("active");
  };

  const handleOutA = (event) => {
    const targetElement = event.currentTarget;

    if (
      !$(targetElement).is(event.relatedTarget) &&
      !$(targetElement).has(event.relatedTarget).length &&
      !$(event.relatedTarget).closest('.dropdown').length &&
      !$(event.relatedTarget).closest('.nav_bar').length &&
      !$(event.relatedTarget).closest('.nav_bar_box').length
    ) {
      $(".txtA").removeClass("active")
      $(".dropdown").css("opacity", 0);
      $(".nav_bar").css({ width: 0 });
      $(".nav_bar_box").css({ width: 0 });
      setDropAIndex(-1);
    }
  };

  let [nav, setNav] = useState([
    { key: 'dropA, txtA', value: ai("게임정보") },
    { key: 'dropA, txtA', value: ai("새소식") },
    { key: 'txtA', value: "다운로드" },
    { key: 'txtA', value: ai45("E스포츠") },
    { key: 'dropA, txtA', value: ai("이벤트") },
    { key: 'dropA, txtA', value: ai("알아보기") },
    { key: 'txtA', value: ai45("유니버스") },
    { key: 'txtA', value: ai45("라이엇 스토어") },
    { key: 'txtA', value: ai45("고객지원") }
  ]);

  let [dropdown, setDropdown] = useState([["기본정보", "챔피언", "패치노트"],
  ["전체", "게임 업데이트", "개발자 블로그", "세계관", "미디어", "라이엇 스토어", "E스포츠", "라이엇 게임즈", "커뮤니티", dropLink("서버 점검 및 업데이트"), "티모 문화유산 원정대"],
  [dropLink("PC방 이벤트"), dropLink("PC방 습격! 이벤트")],
  ["LoL 디스플레이", "모바일 상점", "라이엇 모바일", "아바타 생성기"]])

  {
    nav.map((navitem, navindex) => {
      const className = navitem.key.split(', ').join(' ');
      return (
        <a className={className} href='#' key={navindex}>
          {navitem.value}
        </a>
      );
    })
  }

  const [logoSrc, setLogoSrc] = useState(process.env.PUBLIC_URL + "/navLogo1_1.png");

  const handleOnLogo = () => {
    setLogoSrc(process.env.PUBLIC_URL + "/navLogo1_2.png");
    $(".nav a").eq(0).css("color", "#eb0029")
  };

  const handleOutLogo = () => {
    setLogoSrc(process.env.PUBLIC_URL + "/navLogo1_1.png");
    $(".nav a").eq(0).css("color", "#fff")
  };

  const handleSideNav = (e) => {
    e.preventDefault()
    if ($(e.target).attr("class") == "between side_nav_a side_nav_drop") {
      $(e.target).next('.side_nav_none').toggleClass('active');
      $(e.target).children(".txt45").toggleClass("active")
    }
    else if (e.target.tagName == "path") {
      $(e.target).parent().parent().next('.side_nav_none').toggleClass('active');
      $(e.target).parent().parent().children(".txt45").toggleClass("active")
    }
    else {
      $(e.target).parent().next('.side_nav_none').toggleClass('active');
      $(e.target).next(".txt45").toggleClass("active")
    }
  };

  let [txtAIndex, setTxtAIndex] = useState(0)
  let [dropAIndex, setDropAIndex] = useState(0)

  return (
    <div className="App">
      <div className='nav'>
        <div className='nav_left'>
          <a href="" className='mr-20' onMouseOver={handleOnLogo} onMouseLeave={handleOutLogo}><img src={logoSrc} alt="navLogo1" width="90px" />&nbsp;<FontAwesomeIcon icon={faCaretDown} /></a>
          <a href="" className='mr-20'><img id='navLogo4' src={process.env.PUBLIC_URL + "/navLogo4.png"} alt="navLogo4" width="38px" /></a>
          {
            nav.map((navitem, navindex) => {
              const className = navitem.key.length == 11 ? 'dropA txtA' : 'txtA';
              return (
                <a className={className} href='#' key={navindex} onMouseOver={handleOnA} onMouseOut={handleOutA} onClick={(e) => { e.preventDefault() }}>
                  {navitem.value}
                </a>
              );
            })
          }
        </div>
        <div className='nav_right'>
          <a href="" className='center' style={{ padding: "12px", fontSize: "22px", backgroundColor: "#2b2a28", borderRadius: "100%" }}><FontAwesomeIcon icon={faMagnifyingGlass} /></a>
          <a href="" className='globe center mr-8'><FontAwesomeIcon icon={faGlobe} /></a>
          <a href="" className='signUp mr-11'>로그인</a>
          <a href="" className='signIn' style={{ color: "#000" }}>회원가입</a>
        </div>
        <Button className='nav_Btn' variant="primary" onClick={handleShow} style={{ borderRadius: "10px", backgroundColor: "#2b2a28", border: 0, display: "none" }}>
          <FontAwesomeIcon icon={faBars} />
        </Button>

        <Offcanvas show={show} onHide={handleClose} placement={"end"} style={{ color: "#fff", backgroundColor: "#1F1F1F" }}>
          <Offcanvas.Header>
            <Offcanvas.Title><img id='navLogo4' src={process.env.PUBLIC_URL + "/navLogo5.png"} alt="navLogo5" width="70px" /></Offcanvas.Title>
            <button style={{ backgroundColor: "transparent", border: "none" }} onClick={handleClose}><img src={`${process.env.PUBLIC_URL}/closeBtn2.png`} alt='닫기버튼' width={"20px"}></img></button>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <div className='side_nav'>
              <div className='between side_nav_a side_nav_drop' onClick={(e) => { handleSideNav(e) }}><a href=''>게임정보</a><FontAwesomeIcon icon={faCaretDown} className='txt45' /></div>
              <div className='side_nav_none'>
                <p className='side_nav_a' href=''>기본정보</p>
                <p className='side_nav_a' href=''>챔피언</p>
                <p className='side_nav_a' href=''>패치노트</p>
              </div>

              <div className='between side_nav_a side_nav_drop' onClick={(e) => { handleSideNav(e) }}><a href=''>새소식</a><FontAwesomeIcon icon={faCaretDown} className='txt45' /></div>
              <div className='side_nav_none'>
                <p className='side_nav_a' href=''>전체</p>
                <p className='side_nav_a' href=''>게임 업데이트</p>
                <p className='side_nav_a' href=''>공지</p>
                <p className='side_nav_a' href=''>개발자 블로그</p>
                <p className='side_nav_a' href=''>세계관</p>
                <p className='side_nav_a' href=''>미디어</p>
                <p className='side_nav_a' href=''>라이엇 스토어</p>
                <p className='side_nav_a' href=''>E스포츠</p>
                <p className='side_nav_a' href=''>라이엇 게임즈</p>
                <p className='side_nav_a' href=''>커뮤니티</p>
                <p className='side_nav_a' href=''>서버 점검 및 업데이트</p>
                <p className='side_nav_a' href=''>티모 문화유산 원정대</p>
              </div>

              <div className='between side_nav_a'><a href=''>다운로드</a></div>
              <div className='between side_nav_a'><a href=''>E스포츠</a><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)" }} /></div>

              <div className='between side_nav_a side_nav_drop' onClick={(e) => { handleSideNav(e) }}><a href=''>이벤트</a><FontAwesomeIcon icon={faCaretDown} className='txt45' /></div>
              <div className='side_nav_none'>
                <p className='side_nav_a' href=''>PC방 이벤트</p>
              </div>

              <div className='between side_nav_a side_nav_drop' onClick={(e) => { handleSideNav(e) }}><a href=''>알아보기</a><FontAwesomeIcon icon={faCaretDown} className='txt45' /></div>
              <div className='side_nav_none'>
                <p className='side_nav_a' href=''>LoL 디스플레이</p>
                <p className='side_nav_a' href=''>모바일 상점</p>
                <p className='side_nav_a' href=''>라이엇 모바일</p>
                <p className='side_nav_a' href=''>아바타 생성기</p>
              </div>

              <div className='between side_nav_a'><a href=''>유니버스</a><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)" }} /></div>
              <div className='between side_nav_a'><a href=''>라이엇 스토어</a><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)" }} /></div>
              <div className='between side_nav_a'><a href=''>고객지원</a><FontAwesomeIcon icon={faArrowUp} style={{ transform: "rotate(45deg)" }} /></div>
              <div>
                <p className='side_nav_bottom in' href=''>로그인</p>
                <p className='side_nav_bottom up' href=''>회원가입</p>
              </div>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
        <div className='nav_bar_box'></div>
        <div className='nav_bar'></div>
        {
          document.querySelectorAll('.txtA').length >= 1 && dropdown.map((navitem, index) => {
            const dropAElement = $('.dropA').eq(index);

            return (
              dropAElement && (
                <div onMouseOut={handleOutA} className='dropdown' key={index} style={{ position: "absolute", left: dropAElement.offset()?.left, top: "67px", zIndex: "10" }}>
                  {
                    navitem.map((item, innerIndex) => (
                      <a href='' key={innerIndex} onClick={(e) => { e.preventDefault() }}>{item}</a>
                    ))
                  }
                </div>
              )
            )
          })
        }


      </div>
      <Main />
      <Section1 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
      <Footer />
    </div>
  );
}

export default App;
